module.exports = __webpack_public_path__ + "img/upload.ba2f11d1.svg";